var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-3ZFPB{-ms-flex-negative:0;flex-shrink:0;width:68px;height:80px;background-image:url(" + escape(require("./logo.svg")) + ");background-position:center;background-size:contain;background-repeat:no-repeat}.smallLogo-1BPfZ{width:35px;height:40px}", ""]);

// exports
exports.locals = {
	"logo": "logo-3ZFPB",
	"smallLogo": "smallLogo-1BPfZ"
};